/**
 * Institution status helpers. Status values from the API are lowercase strings.
 * To change the dropdown options, edit INSTITUTION_STATUS_FILTER_OPTIONS only
 * (and add a matching `status.<value>` key to the institutions i18n files).
 */
export const INSTITUTION_STATUS_FILTER_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "suspended", label: "Suspended" },
  { value: "deleted", label: "Deleted" },
] as const;

/**
 * Statuses an admin can set from the edit form. "deleted" is only a list filter value, it is
 * not selectable here.
 */
export const INSTITUTION_STATUS_FORM_VALUES = ["active", "inactive", "suspended"] as const;

/** Pill colours per status (background + text). */
export const INSTITUTION_STATUS_BADGE_CLASS_MAP: Record<string, string> = {
  active: "bg-[#E8F5E9] text-[#28A745]",
  inactive: "bg-[#EAEAEA] text-[#555555]",
  suspended: "bg-[#FFF4E5] text-[#F59E0B]",
  deleted: "bg-[#FDECEA] text-[#DC3545]",
};

/** Neutral pill for any status the UI does not know about. */
export const INSTITUTION_STATUS_BADGE_FALLBACK_CLASS =
  "bg-[#EAEAEA] text-[#555555]";
